// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media screen and (max-width:992px){.images{--bs-aspect-ratio:75%}}.images .gallery-image{max-height:100%;opacity:0}", ""]);
// Exports
module.exports = exports;
